export default "__VITE_ASSET__7f301467__"